/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArticleModel } from './ArticleModel';
import {
    ArticleModelFromJSON,
    ArticleModelFromJSONTyped,
    ArticleModelToJSON,
} from './ArticleModel';

/**
 *
 * @export
 * @interface ListArticleResponse
 */
export interface ListArticleResponse {
    /**
     *
     * @type {number}
     * @memberof ListArticleResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListArticleResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListArticleResponse
     */
    total: number;
    /**
     *
     * @type {Array<ArticleModel>}
     * @memberof ListArticleResponse
     */
    articles: Array<ArticleModel>;
}

/**
 * Check if a given object implements the ListArticleResponse interface.
 */
export function instanceOfListArticleResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('articles' in value)) return false;
    return true;
}

export function ListArticleResponseFromJSON(json: any): ListArticleResponse {
    return ListArticleResponseFromJSONTyped(json, false);
}

export function ListArticleResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListArticleResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        articles: (json['articles'] as Array<any>).map(ArticleModelFromJSON),
    };
}

export function ListArticleResponseToJSON(value?: ListArticleResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        articles: (value['articles'] as Array<any>).map(ArticleModelToJSON),
    };
}
